import { createAction } from '@reduxjs/toolkit';

export const coursesUpdateId = createAction('courses/updateId');
export const coursesUpdateUID = createAction('courses/updateUid');
export const coursesUpdateSID = createAction('courses/updateSid');
export const coursesUpdateIsAdded = createAction('courses/updateIsAdded');
export const coursesUpdateIsActive = createAction('courses/updateIsActive');

export const coursesUpdateRequesting = createAction('courses/updateRequesting');
export const coursesUpdateRequest = createAction('courses/updateRequest');
export const coursesUpdateError = createAction('courses/updateError');
export const coursesUpdateStore = createAction('courses/updateStore');

export const coursesStore = createAction('courses/store');
export const coursesClear = createAction('courses/clear');

export const coursesUpdateCourses = createAction('courses/updateCourses');

export const coursesUpdateHeadingTitle = createAction('courses/updateHeadingTitle');
export const coursesUpdateHeadingDescription = createAction('courses/updateHeadingDescription');
export const coursesUpdateHeadingTextAlign = createAction('courses/updateHeadingTextAlign');
export const coursesUpdateHeadingImage = createAction('courses/updateHeadingImage');
export const coursesUpdateHeadingDivider = createAction('courses/updateHeadingDivider');

export const coursesUpdateSectionIsBackground = createAction('courses/updateSectionIsBackground');
export const coursesUpdateSectionTextColor = createAction('courses/updateSectionTextColor');
export const coursesUpdateSectionBackgroundColor = createAction('courses/updateSectionBackgroundColor');
export const coursesUpdateSectionOpacity = createAction('courses/updateSectionOpacity');
export const coursesUpdateSectionIsFullWidth = createAction('courses/updateSectionIsFullWidth');
export const coursesUpdateSectionShadow = createAction('courses/updateSectionShadow');
export const coursesUpdateSectionShadowColor = createAction('courses/updateSectionShadowColor');
export const coursesUpdateSectionPadding = createAction('courses/updateSectionPadding');
export const coursesUpdateSectionMargin = createAction('courses/updateSectionMargin');
export const coursesUpdateSectionBackgroundType = createAction('courses/updateSectionBackgroundType');
export const coursesUpdateSectionBackgroundImage = createAction('courses/updateSectionBackgroundImage');
export const coursesUpdateSectionGradientColor1 = createAction('courses/updateSectionGradientColor1');
export const coursesUpdateSectionGradientColor2 = createAction('courses/updateSectionGradientColor2');
export const coursesUpdateSectionGradientDirection = createAction('courses/updateSectionGradientDirection');
export const coursesUpdateSectionGradientOffset = createAction('courses/updateSectionGradientOffset');
export const coursesUpdateSectionBorder = createAction('courses/updateSectionBorder');
export const coursesUpdateSectionBorderColor = createAction('courses/updateSectionBorderColor');
export const coursesUpdateSectionShadowBorderColor = createAction('courses/updateSectionShadowBorderColor');
export const coursesUpdateSectionShape = createAction('courses/updateSectionShape');

export const coursesUpdateItemOpacity = createAction('courses/updateItemOpacity');
export const coursesUpdateItemShadow = createAction('courses/updateItemShadow');
export const coursesUpdateItemShadowColor = createAction('courses/updateItemShadowColor');
export const coursesUpdateItemBorder = createAction('courses/updateItemBorder');
export const coursesUpdateItemBorderColor = createAction('courses/updateItemBorderColor');
export const coursesUpdateItemShape = createAction('courses/updateItemShape');
